import React from 'react'
import { Box, Stack, Heading, Text, Checkbox, Card, Alert } from '@/components/lib'
import api from '../../../api'
import utils from '@/utils/utils'
import useStore from '../../../store'
import scorchHelpful from '../../../images/scorch/helpful.png'
import assistantImage from '../../../images/scorch/assistant.png'
import participantInsightsImage from '../../../images/scorch/participant_insights.png'
import trialInsightsImage from '../../../images/scorch/trial_insights.png'

export default function Scorch ({ trial }) {
  const { user, team, updateTrial } = useStore()

  const hasParticipantInsights = utils.hasFeature(team, 'participantInsights')
  const hasTrialInsights = utils.hasFeature(team, 'trialInsights')

  function update (field, value) {
    api.trials.update(trial._id, { [field]: value }, t => updateTrial(t._id, t), err => utils.toast('error', err.message))
  }

  const upsellAlert = (
    <Alert status='info'>
      This feature is not currently available to your team. Please reach out to your account manager to learn more.
    </Alert>
  )

  return (
    <Stack gap={5}>
      <Card variant='outline'>
        <Box display='flex' alignItems='center' gap={4}>
          <Box as='img' src={scorchHelpful} alt='Scorch' h='64px' style={{ objectFit: 'cover' }} />
          <Box>
            <Heading as='h3' size='md'>Scorch AI</Heading>
            <Text color='fg.muted'>Scorch is Trialflare's built-in AI assistant. It can analyse your trial data, surface insights, and help your team stay on top of what matters.</Text>
          </Box>
        </Box>
      </Card>

      <Stack direction={{ base: 'column', md: 'row' }} gap={5}>
        <Card variant='outline' gap={2}>
          <Heading as='h3' size='md'>Participant insights</Heading>
          <Box>
            <img src={participantInsightsImage} alt='Participant insights' style={{ objectFit: 'cover', height: '100px' }} />
          </Box>
          <Text>When enabled, Scorch will work in the background to analyse responses and surface warnings, trends, and other notable signals.</Text>
          {hasParticipantInsights
            ? <Checkbox isChecked={!!trial.participantInsightsEnabled} onChange={e => update('participantInsightsEnabled', e.checked)}>Enable participant insights</Checkbox>
            : upsellAlert}
        </Card>

        <Card variant='outline' gap={2}>
          <Heading as='h3' size='md'>Trial insights</Heading>
          <Box>
            <img src={trialInsightsImage} alt='Trial insights' style={{ objectFit: 'cover', height: '100px' }} />
          </Box>
          <Text>When enabled, Scorch will generate trial-level insights covering compliance trends, data patterns, and signals from participants.</Text>
          {hasTrialInsights
            ? <Checkbox isChecked={!!trial.trialInsightsEnabled} onChange={e => update('trialInsightsEnabled', e.checked)}>Enable trial insights</Checkbox>
            : upsellAlert}
        </Card>
      </Stack>

      <Card variant='outline' gap={2}>
        <Stack direction='row' gap={5} alignItems='center'>
          <Stack gap={3}>
            <Heading as='h3' size='md'>Assistant</Heading>
            <Text>Scorch can act as an asisstant to you and your team. It can answer questions about your data and help you manage your trial.</Text>
            {(utils.hasFeature(team, 'aiAssistant') && utils.canUseTrialAssistant(user, trial))
              ? <Alert status='success'>Assistant is enabled</Alert>
              : upsellAlert}
          </Stack>
          <Box w='250px' overflow='clip' rounded='md' shadow='md'>
            <img src={assistantImage} alt='Assistant' />
          </Box>
        </Stack>
      </Card>
    </Stack>
  )
}
